// extracted by mini-css-extract-plugin
export default {"widget":"style_widget__joZYZ","widgetMsg":"style_widgetMsg__Rvh2Z","containerFav":"style_containerFav__DtknN","fav":"style_fav__h0tF8","favName":"style_favName__MYpPx"};